export const urls = {
  // TODO these urls should not be hardcoded
  links: {
    projectAttachment(projectId: number, attachmentId: number) {
      return `buyer/api/project/${projectId}/attachment/${attachmentId}`
    },
    projectIssueAttachment(
      projectId: number,
      issueId: number,
      attachmentId: number
    ) {
      return `buyer/api/project/${projectId}/issue/${issueId}/attachment/${attachmentId}`
    },
    uploadProjectAttachment(projectId: number) {
      return `buyer/api/project/${projectId}/attachment/`
    },
    uploadSectionAttachment(projectId: number, sectionId: number) {
      return `buyer/api/project/${projectId}/section/${sectionId}/excel`
    },
    qTextReport(projectId: number) {
      return `buyer/api/project/${projectId}/report/qtext`
    },
  },
}
